import { getText } from '../internal/TextLabels'

export const OngoingPaymentHeaders = delayedPaymentAutomaticDebitDateEnabled =>
  [
    {
      id: 'status',
      label: getText('ongoingPayments.headers.status'),
      nonSortable: true,
    },
    {
      id: 'customer',
      label: getText('ongoingPayments.headers.customer'),
      dataCy: 'created',
      nonSortable: true,
    },
    {
      id: 'seller',
      label: getText('ongoingPayments.headers.seller'),
      nonSortable: true,
    },
    {
      id: 'paymentMethod',
      label: getText('ongoingPayments.headers.method'),
      nonSortable: true,
    },
    {
      id: 'amount',
      type: 'number',
      label: getText('ongoingPayments.headers.amount'),
    },
    delayedPaymentAutomaticDebitDateEnabled && {
      id: 'automaticDebitDate',
      type: 'date',
      label: getText('ongoingPayments.headers.debitDate'),
    },
    {
      id: 'dueDate',
      type: 'date',
      label: getText('ongoingPayments.headers.dueDate'),
      nonSortable: true,
    },
  ].filter(item => !!item)
